import { render, staticRenderFns } from "./MicroCreditProductForm.vue?vue&type=template&id=4f92cd4d&"
import script from "./MicroCreditProductForm.vue?vue&type=script&lang=js&"
export * from "./MicroCreditProductForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports